import { forwardRef } from "react";
import { Rect, Text, Group } from "react-konva";
import PropTypes from "prop-types";

const BlocksBoxComponent = forwardRef( 
    ({ xOffset, yOffset, page, hoveredChunkId, setHoveredChunkId}) => {

    const baseWidth = page.width_px;
    const baseHeight = page.height_px;

    const boxes = 
        page.chunks?.map((chunk) => ({
            id: chunk.chunk_id,
            type: chunk.chunk_type,
            x: chunk.grounding.box.left,
            y: chunk.grounding.box.top,
            width: chunk.grounding.box.right - chunk.grounding.box.left,
            height: chunk.grounding.box.bottom - chunk.grounding.box.top,
        }))


    return (
        <>
            {boxes.map((box, index) => {
                const isHovered =
                    hoveredChunkId === box.id;

                const x = box.x * baseWidth + xOffset;
                const y = box.y * baseHeight + yOffset;
                const w = box.width * baseWidth;
                const h = box.height * baseHeight;

                return (
                    <Group key={box.id}>
                        {/* BOX */}
                        <Rect
                            x={x}
                            y={y}
                            width={w}
                            height={h}
                            stroke={
                                isHovered
                                    ? "#deb9ef"
                                    : "#00A3FF"
                            }
                            strokeWidth={
                                isHovered ? 3 : 2
                            }
                            fill={
                                isHovered
                                    ? "rgba(219,197,236,0.2)"
                                    : "rgba(0,163,255,0.15)"
                            }
                            onMouseEnter={() => {
                                setHoveredChunkId(
                                    box.id
                                );
                                document.body.style.cursor =
                                    "pointer";
                            }}
                            onMouseLeave={() => {
                                setHoveredChunkId(null);
                                document.body.style.cursor =
                                    "crosshair";
                            }}
                        />

                        {/* TOOLTIP */}
                        {isHovered && (
                            <Group>
                                <Rect
                                    x={x}
                                    y={y - 28}
                                    width={90}
                                    height={22}
                                    fill="#deb9ef"
                                    cornerRadius={4}
                                    shadowBlur={4}
                                />
                                <Text
                                    x={x + 6}
                                    y={y - 24}
                                    text={box.type || "unknown"}
                                    fontSize={14}
                                    fill="#000"
                                />
                            </Group>
                        )}
                    </Group>
                );
            })}
        </>
    )

}
);


BlocksBoxComponent.propTypes = {
    xOffset: PropTypes.number.isRequired,
    yOffset: PropTypes.number.isRequired,    
    page: PropTypes.object,
    zoom: PropTypes.number,
    hoveredChunkId: PropTypes.string,
    setHoveredChunkId: PropTypes.func,
};

export default BlocksBoxComponent;
